import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useRidesMapToggleButton } from "@ryde/redux";
import { TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { MapToggleButtonStyled } from "./elements.styled";

export const RidesMapToggleButton: FC = () => {
  const { buttonColor, toggleMapOpen } = useRidesMapToggleButton();

  const { t } = useTranslation();

  return (
    <FramerTooltip
      content={t("ui.TOGGLE_MAP")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <MapToggleButtonStyled onClick={toggleMapOpen}>
        <SVG_MUI.MapToggle4SVG
          fill={buttonColor}
          className="MapToggleButtonSVG"
        />
        <label style={{ color: buttonColor }}>{t("ui.MAP")}</label>
      </MapToggleButtonStyled>
    </FramerTooltip>
  );
};
